export const state = [
	{
		name: 'nsw',
		label: 'NSW',
	},
	{
		name: 'vic',
		label: 'VIC',
	},
	{
		name: 'qld',
		label: 'QLD',
	},
	{
		name: 'wa',
		label: 'WA',
	},
	{
		name: 'sa',
		label: 'SA',
	},
	{
		name: 'tas',
		label: 'TAS',
	},
	{
		name: 'act',
		label: 'ACT',
	},
	{
		name: 'nt',
		label: 'NT',
	},
];

const fileMime = {
	pdf: '.pdf',
	doc: '.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
	xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel',
	img: 'image/png,image/jpg',
};

type MimeType = 'PDF' | 'DOC' | 'XLSX' | 'IMG';

export const getFileMime = (type?: MimeType) => {
	if (type === undefined) {
		return Object.values(fileMime).join(',');
	}

	return fileMime[type.toLowerCase() as keyof typeof fileMime];
};

export const publicHolidays = [
	'2025-12-25',
	'2025-12-26',
	'2026-01-01', // New Year’s Day
	'2026-01-26', // Australia Day
	'2026-04-03', // Good Friday
	'2026-04-04', // Easter Saturday
	'2026-04-05', // Easter Sunday
	'2026-04-06', // Easter Monday
	'2026-04-25', // Anzac Day
	'2026-06-08', // King’s Birthday
	'2026-10-05', // Labour Day
	'2026-12-25', // Christmas Day
	'2026-12-28', // Additional Boxing Day holiday
];

export const baseUrl = process.env.REACT_APP_PES_API_URL;

// a hack to hide development work from users
export const isProd = process.env.REACT_APP_PES_API_URL === 'https://api.pes.ausrehab.com';
